<template lang="pug">
  .iframe-container(:class="[spacingTop, spacingBottom]")
    .container.mx-auto
        iframe(v-if="url" :src="url" :style="{ height: `${height}` }")
        .noURL(v-else) Bitte geben Sie eine URL ein, unter Einstellungen.
</template>

<script>
export default {
    name: 'Iframe',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    computed: {
        url() {
            let url = undefined;

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'url');
                if (setting && setting.value !== undefined) url = setting.value;
            }
            return url;
        },

        height() {
            let height = '800px';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'height');
                if (setting && setting.value !== undefined) height = setting.value;
            }

            return height;
        },

        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },

        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        }
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

.iframe-container
  iframe
    @apply w-full
</style>
